import { TFormSubmission } from "@/types/trpc.types";
import { Field } from "../../forms/form-editor/canvas";
import { FieldTypeName } from "../../forms/form-editor/fields";

type Props = {
  form_submission?: TFormSubmission;
};

const InlineViewer = ({ form_submission:form }: Props) => {
  return (
    <div className="flex flex-col gap-4">
      {form?.name && <h1 className="text-3xl font-bold first-letter:uppercase">{form?.name}</h1>}
      {form?.description && <p className="text-neutral-800">{form?.description}</p>}

      <div className="flex flex-col gap-8">
        {form?.fields?.map((field) => {
          return (
            <div
              className="w-full overflow-hidden border rounded-md shadow-sm"
              key={field.id}
            >
              <Field
                field={{
                  id: field.id,
                  name: field.name ?? "",
                  type: field.type as FieldTypeName,
                  required: field.required ?? false,
                  parent: field.parent_id,
                  question: field.question ?? "",
                  options:
                    "options" in field
                      ? field.options?.map((option) => ({
                          id: option.id,
                          text: option.text ?? "",
                        }))
                      : [],
                }}
                preview
                disabled
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InlineViewer;
